import { Box } from '@mui/material'
import { useContext } from 'react'

// others
import { AppContext } from '../../context'
import { ActionType } from '../../context/AppContextReducer'
import { NOT_APPLICABLE } from '../../constants'
import { ReferenceMenuProps } from '../../interfaceTypes/props'
import { useDeleteReferenceMutation } from '../../../generated'

// components
import { Alert } from '../common/Alert'
import CustomMenu from '../common/CustomMenu'
import { DeleteModalContent } from '../common/DeleteModalContent'
import AddReference from '../referralSources/AddReference'

const Reference = ({ reference, refetch }: ReferenceMenuProps) => {
  const { dispatch, isOpen } = useContext(AppContext)
  const toggleLabel = reference?.active ? 'Deactivate' : 'Activate'

  const [deleteReference, { loading: deleting }] = useDeleteReferenceMutation({
    onError: error => {
      Alert.error(`Reference couldn't be updated due to: ${error.message}`)
    },
    onCompleted: () => {
      dispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: false })
      Alert.success(`Referral source ${toggleLabel.toLowerCase()}d successfully`)
      refetch()
    }
  })

  const onDeleteReference = async (referenceId: string) =>
    await deleteReference({ variables: { deleteReferenceId: referenceId } })

  return (
    <CustomMenu
      id={reference?.id || ''}
      menuTitle="Referral Source"
      deleteLabel={toggleLabel}
      onDelete={onDeleteReference}
      deleteContent={
        <Box mt={1}>
          <DeleteModalContent label="Source" value={reference?.referralSource.sourceType || NOT_APPLICABLE} />
          <DeleteModalContent label="Reference" value={reference?.referral || NOT_APPLICABLE} />
        </Box>
      }
      deleting={deleting}
      modal={
        <AddReference
          isOpen={isOpen}
          handleClose={() => dispatch({ type: ActionType.SET_IS_OPEN, isOpen: false })}
          refetch={refetch}
          reference={reference}
        />
      }
    />
  )
}

export default Reference
